// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"252":"cb8045b4","770":"2140fa3b","812":"366e44fe"}[chunkId] + ".css";
};